import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const NAV = [
  { path: '/admin', icon: '📊', label: 'Dashboard' },
  { path: '/admin/users', icon: '👥', label: 'Users' },
  { path: '/admin/payments', icon: '✅', label: 'Payments' },
  { path: '/admin/leads', icon: '📋', label: 'Website Leads' },
  { path: '/admin/tickets', icon: '🎫', label: 'Support Tickets' },
  { path: '/admin/announcements', icon: '📣', label: 'Announcements' },
  { path: '/admin/notifications', icon: '🔔', label: 'Notifications' },
];

export default function AdminLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const logout = () => { localStorage.removeItem('msreach_admin_token'); navigate('/admin/login'); };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>
      <aside style={{
        width: 240, flexShrink: 0, background: 'var(--bg-card)',
        borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column',
        position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100, overflowY: 'auto'
      }}>
        <div style={{ padding: '18px 16px 14px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 34, height: 34, background: '#ffd700', borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>🔐</div>
            <div>
              <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 16, color: '#ffd700' }}>Admin</div>
              <div style={{ fontSize: 9, color: 'var(--text-muted)', letterSpacing: 1.5 }}>MS REACH</div>
            </div>
          </div>
        </div>
        <nav style={{ flex: 1, padding: '10px 8px', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {NAV.map(item => {
            const active = location.pathname === item.path || (item.path !== '/admin' && location.pathname.startsWith(item.path));
            return (
              <Link key={item.path} to={item.path} style={{
                display: 'flex', alignItems: 'center', gap: 10,
                padding: '9px 12px', borderRadius: 8,
                color: active ? '#ffd700' : 'var(--text-muted)',
                background: active ? 'rgba(255,215,0,0.08)' : 'transparent',
                fontSize: 13, fontWeight: active ? 600 : 400, textDecoration: 'none', transition: 'all 0.15s'
              }}><span style={{ fontSize: 15, width: 20, textAlign: 'center' }}>{item.icon}</span>{item.label}</Link>
            );
          })}
        </nav>
        <div style={{ padding: 14, borderTop: '1px solid var(--border)' }}>
          <button onClick={logout} style={{
            width: '100%', background: 'transparent', border: '1px solid var(--border)',
            color: 'var(--text-muted)', padding: '9px 12px', borderRadius: 8, fontSize: 13, cursor: 'pointer'
          }}>🚪 Logout</button>
        </div>
      </aside>
      <main style={{ flex: 1, marginLeft: 240, minWidth: 0 }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '12px 24px', borderBottom: '1px solid var(--border)', background: 'var(--bg-card)' }}>
          <span style={{ background: 'rgba(255,215,0,0.1)', color: '#ffd700', padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 700 }}>🔐 ADMIN</span>
        </div>
        <div style={{ padding: 24, animation: 'fadeIn 0.25s ease' }}>{children}</div>
      </main>
    </div>
  );
}
